import ProductFilters                                   from "./ProductFilters";
import { addListener } from "../../../../../../resources/js/utils";
import ProductActions  from "../mixin/ProductAction";
import {BRDropdown}    from "@dbetts/brjstools";

class ProductGrid extends ProductFilters
{
    itemsPerPage = '12';
    sortByType = '1';
    CategoryController = new AbortController();

    constructor()
    {
        super();

        this.pagingChange = this.pagingChange.bind(this);
        this.pagingPageNumber = this.pagingPageNumber.bind(this);
        this.setSortBy = this.setSortBy.bind(this);

        this.PGInit();
    }

    PGInit()
    {
        this.setListeners();
        BRDropdown.initAll();

        // Get itemsPerPage from the browser storage
        // Get itemsPerPage and sortByType from browser storage
        this.itemsPerPage = localStorage.getItem('itemsPerPage') || '12';
        this.sortByType = localStorage.getItem('sortByType') || '1';

        const showOutOfStock = localStorage.getItem('showOutOfStock') || '1';
        this.setShowOOS(showOutOfStock);

        // Handle back button navigation
        window.addEventListener('popstate', (evt) => {
            if (evt.state && evt.state.pageURL) {
                this._getPageContent(evt.state.pageURL, false).then(r => {});
            }
        });
    }

    setListeners()
    {
        addListener('click', '[id^="popup_count_"] li[data-value]', this.pagingChange);
        addListener('click', '[id^="popup_options_"] [id^="sub_popup_count_"] li[data-value]', this.pagingChange);
        addListener('change', '.pagingPageNumber', this.pagingPageNumber);
        addListener('click', '[id^="popup_sort_"] li[data-value]', this.setSortBy);
        addListener('click', '[id^="popup_options_"] [id^="sub_popup_sort_"] li[data-value]', this.setSortBy);

        ProductActions.setAllProductListeners();
    }

    pagingChange(evt)
    {
        const liElement = evt.currentTarget;

        this.itemsPerPage = liElement.getAttribute('data-value');
        localStorage.setItem('itemsPerPage', this.itemsPerPage);
        this.reloadPage(1);
    }

    /*setItemsPerPage(value)
    {
        if (this.itemsPerPage !== value) {
            this.itemsPerPage = value;

            localStorage.setItem('itemsPerPage', this.itemsPerPage);
            this.reloadPage(1);
        }
    }*/

    pagingPageNumber(evt)
    {
        this.reloadPage(evt.currentTarget.value)
    }

    setSortBy(evt)
    {
        const liElement = evt.currentTarget;
        const sortByType = liElement.getAttribute('data-value');
        if (this.sortByType !== sortByType) {
            this.sortByType = sortByType;
            localStorage.setItem('sortByType', sortByType);
            this.reloadPage(1)
        }
    }

    setSortByType(value)
    {
        this.sortByType = value;
    }

    reloadPage(page)
    {
        // Perform a DB request with the new checkboxes.
        let pageURL = this._pullPageFilterData();
        this._getPageContent(pageURL + '&page=' + page).then(r => {
        });
    }

    getItemsPerPage()
    {
        return this.itemsPerPage;
    }

    getSortByType()
    {
        return this.sortByType;
    }

    async _getPageContent(pageURL, saveState = true)
    {
        return await new Promise(async(resolve, reject) => {

            // Abort any previous Autocomplete request
            this.CategoryController.abort();

            // Re-instantiate another instance of AbortController()
            this.CategoryController = new AbortController();


            axios.get(pageURL, {
                          signal: this.CategoryController.signal
                      }
            )
                .then(res => {
                          let data = res.data;
                          if ( data.Status === 'Success' ) {
                              this.setProductsContent(pageURL, data.Result, saveState);
                          }

                          return resolve(res);
                      }
                )
                .catch(error => {
                           if ( error.message !== 'canceled' ) {
                               console.error(error)
                               return reject(error)
                           }
                       }
                );
        });
    }

    setProductsContent(pageURL, result, saveState)
    {
        // Set the left category/filter menu
        if (result.categories) {
            document.getElementById('categories_container').innerHTML = result.categories;
            document.getElementById('searchFilters').innerHTML = result.search_filter;
        }
        const searchPageHeader = document.getElementById('searchChildHeader');
        if (searchPageHeader) {
            searchPageHeader.innerHTML = result.products_header;
        }
        if (result.pagination) {
            // This should always be the top paginator
            document.getElementById('productCounts').innerHTML = result.pagination;
        }
        this.PFInit();

        // Set the product list
        const newProductGrid = document.createElement('div');
        newProductGrid.innerHTML = result.products;
        const newContent = newProductGrid.firstChild;
        const currentProductGrid = document.getElementById('productGridContainer');
        // Replace the current productGrid with the new one
        if ( currentProductGrid && newContent ) {
            currentProductGrid.parentNode.replaceChild(newContent, currentProductGrid);
            this.PGInit();
        }

        // Set a new title
        document.title = result.documentTitle;

        // Update the URL and history after content is loaded
        if (saveState)
            window.history.pushState({pageURL: pageURL}, "", pageURL);
    }
}

export default ProductGrid;